export default __webpack_public_path__ + "static/media/popup-banner.a1bd6341.svg";